import { MediaitemModel, MediaitemType } from '@models';
import MediaitemAudioThumbnail from './MediaitemAudioThumbnail';
import MediaitemImageThumbnail from './MediaitemImageThumbnail';
import MediaitemVideoThumbnail from './MediaitemVideoThumbnail';

const MediaitemThumbnail = ({
  mediaitem,
  type = 'small',
  imageClassName,
  onImageLoaded
}: {
  mediaitem: MediaitemModel;
  type: 'small' | 'large';
  imageClassName?: string;
  onImageLoaded?: () => void;
}) => {
  return (
    <div className='w-full'>
      {mediaitem.type === MediaitemType.IMAGE && (
        <MediaitemImageThumbnail
          mediaitem={mediaitem}
          type={type}
          imageClassName={imageClassName}
          onImageLoaded={onImageLoaded}
        />
      )}
      {mediaitem.type === MediaitemType.AUDIO && <MediaitemAudioThumbnail type={type} />}
      {mediaitem.type === MediaitemType.VIDEO && (
        <MediaitemVideoThumbnail mediaitem={mediaitem} type={type} />
      )}
    </div>
  );
};

export default MediaitemThumbnail;
